import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import TruckSection from './components/TruckSection';
import ReasonsSection from './components/ReasonsSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import FlowSection from './components/FlowSection';
import CasesSection from './components/CasesSection';
import VoicesSection from './components/VoicesSection';
import FAQSection from './components/FAQSection';
import CompanySection from './components/CompanySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import MobileCTA from './components/MobileCTA';

export default function HomePage() {
  return (
    <div className="w-full min-w-[320px] bg-background-50 text-foreground-950">
      <Header />
      <main>
        <HeroSection />
        <TrustBadges />
        <TruckSection />
        <ReasonsSection />
        <ServicesSection />
        <PricingSection />
        <FlowSection />
        <CasesSection />
        <VoicesSection />
        <FAQSection />
        <CompanySection />
        <ContactSection />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}